export const isDeveloperMode = () => {
  return import.meta.env.MODE === 'development'
}
